import { render, staticRenderFns } from "./ShapeBgCardBlock.vue?vue&type=template&id=63de6fcc&"
import script from "./ShapeBgCardBlock.vue?vue&type=script&lang=js&"
export * from "./ShapeBgCardBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShapeBgCard: require('/server/itg-custom/staging/front/components/ShapeBgCard/ShapeBgCard.vue').default,CardsGrid: require('/server/itg-custom/staging/front/components/CardsGrid.vue').default})
